var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import TextBox from './components/TextBox';
import history from './history';
import { Container } from './services/di';
import { Button } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import { ControlType } from './api';
var LoginPage = /** @class */ (function (_super) {
    __extends(LoginPage, _super);
    function LoginPage(props, ctx) {
        var _this = _super.call(this, props, ctx) || this;
        _this.state = {
            dataState: Container.createDataStateService(),
            loading: false,
            errorMessage: null
        };
        return _this;
    }
    LoginPage.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/];
            });
        });
    };
    LoginPage.prototype.login = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setState({
                            loading: true
                        });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, Container.http.post("/identities/login", this.state.dataState.record)];
                    case 2:
                        result = _a.sent();
                        this.state.dataState.validationReset.next();
                        if (result.token) {
                            localStorage.setItem('jwt', result.token);
                            history.push('/');
                        }
                        return [3 /*break*/, 5];
                    case 3:
                        error_1 = _a.sent();
                        this.state.dataState.validationReset.next();
                        if (error_1.response.status == 400) {
                            this.state.dataState.emitValidationErrors(error_1.response.data.errors);
                        }
                        else {
                            this.setState({
                                errorMessage: error_1.response.data.message
                            });
                        }
                        return [3 /*break*/, 5];
                    case 4:
                        this.setState({
                            loading: false
                        });
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    LoginPage.prototype.render = function () {
        var _this = this;
        return (this.state.dataState &&
            React.createElement("div", { style: { width: '400px', margin: '20px auto' } },
                React.createElement("div", null, "P\u0159ihl\u00E1\u0161en\u00ED"),
                this.state.errorMessage && React.createElement(Alert, { severity: "error" }, this.state.errorMessage),
                React.createElement(TextBox, { control: { kind: ControlType.Textbox, label: 'E-mail', path: 'username' }, dataState: this.state.dataState }),
                React.createElement(TextBox, { options: { type: 'password' }, control: { kind: ControlType.Textbox, label: 'Heslo', path: 'password' }, dataState: this.state.dataState }),
                React.createElement(Button, { onClick: function () { return _this.login(); } }, "P\u0159ihl\u00E1sit se")));
    };
    return LoginPage;
}(React.Component));
export default LoginPage;
//# sourceMappingURL=LoginPage.js.map